import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export const FindStores = universal(
    universalImport({
        chunkName: () => 'CartPageWrapperComponentsLazy',
        path: () =>
            path.join(__dirname, 'yoda-site-components/lib/components/FindStores/FindStores'),
        resolve: () =>
            require.resolveWeak('yoda-site-components/lib/components/FindStores/FindStores'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "CartPageWrapperComponentsLazy" */ 'yoda-site-components/lib/components/FindStores/FindStores'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);

/* istanbul ignore next */
export const SingleClickCheckoutWrapper = universal(
    universalImport({
        chunkName: () => 'CartPageWrapperComponentsLazy',
        path: () =>
            path.join(
                __dirname,
                '../../../../components/SingleClickCheckoutWrapper/SingleClickCheckoutWrapper'
            ),
        resolve: () =>
            require.resolveWeak(
                '../../../../components/SingleClickCheckoutWrapper/SingleClickCheckoutWrapper'
            ),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "CartPageWrapperComponentsLazy" */ '../../../../components/SingleClickCheckoutWrapper/SingleClickCheckoutWrapper'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);

/* istanbul ignore next */
export const ItemFulfillmentsNew = universal(
    universalImport({
        chunkName: () => 'CartPageWrapperComponentsLazy',
        path: () =>
            path.join(__dirname, '../../../../components/ItemFulfillmentsNew/ItemFulfillmentsNew'),
        resolve: () =>
            require.resolveWeak('../../../../components/ItemFulfillmentsNew/ItemFulfillmentsNew'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "CartPageWrapperComponentsLazy" */ '../../../../components/ItemFulfillmentsNew/ItemFulfillmentsNew'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);
